import React, { createContext, useReducer, ReactNode, Dispatch } from 'react';
import Reducer, { Action, EmailFieldState } from '../../reducers/regform-fields/email-field-reducer';

type EmailFieldContextType = [EmailFieldState, Dispatch<Action>];

const initialState: EmailFieldState = {
	value: '',
	error: {
		message: '',
		show: false,
	},
	valid: null,
};

export const EmailFieldContext = createContext<EmailFieldContextType>([initialState, () => null]);

interface EmailFieldStoreProps {
	children: ReactNode;
}

const EmailFieldStore: React.FC<EmailFieldStoreProps> = ({ children }) => {
	const [state, dispatch] = useReducer(Reducer, initialState);
	return (
		<EmailFieldContext.Provider value={[state, dispatch]}>
			{children}
		</EmailFieldContext.Provider>
	);
};

export default EmailFieldStore;
